export const getFilenameFromHeader = (header) => {
  const filenameRegex = /filename\*?=(?:UTF-8''|\"?)([^;\"]+)/i;
  const matches = filenameRegex.exec(header);
  if (matches && matches[1]) {
    return decodeURIComponent(matches[1].replace(/\"/g, ''));
  }
  return null;
};
